/* eslint-disable jsx-a11y/no-static-element-interactions */
/**
 * ProductCard.jsx  (Desktop)
 * ─────────────────────────────────────────────────────────
 * Desktop product card component. Clicking "Add to cart" now
 * opens the ProductModal instead of navigating to the product
 * page, giving users a quick-add experience without leaving the menu.
 *
 * All products — including those whose SKU previously triggered
 * a direct cart add — now route through the modal so users can
 * adjust quantity and add notes.
 */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { _ } from '@evershop/evershop/src/lib/locale/translate';
import { useLanguage } from '@components/common/locale/useLanguage';
import './ProductCard.scss';
import NoThumbnail from '@components/frontStore/catalog/product/single/NoThumbnail';
import NewItemIcon from '../newItemIcon/NewItemIcon';
import ProductModal from '../productModal/ProductModal';
import { useProductModal } from '../productModal/useProductModal';
export default function ProductCard(_ref) {
  var {
    storeStatus,
    image,
    name,
    description,
    descriptionAr,
    price,
    currency = 'EGP',
    url,
    stockAvailability = true,
    loading = false,
    isNewItem,
    isSpicy,
    productId,
    isCustomizable,
    nameAr
  } = _ref;
  /* ── Modal state ── */
  var {
    isOpen,
    product: modalProduct,
    openModal,
    closeModal
  } = useProductModal();
  var {
    isAr
  } = useLanguage();
  var isNew = isNewItem === null || isNewItem === void 0 ? void 0 : isNewItem.is_new_item;
  var hasPrice = price != null && Number(price) > 0;
  var displayPrice = hasPrice ? Number(price).toFixed(2) : '';
  /**
   * Open the modal with this product's data.
   * All products now go through the modal (no SKU bypass).
   */
  var handleButtonClick = () => {
    if (storeStatus === '0') return;
    openModal({
      productId,
      image,
      name: isAr ? nameAr || name : name,
      description: isAr && descriptionAr ? descriptionAr : description,
      price: Number(price) || 0,
      currency,
      url
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "product-card relative cursor-pointer flex flex-col justify-between mx-auto "
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative h-20 w-full mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute left-1/2 top-[-6.25rem] -translate-x-1/2 z-10 w-full flex justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("a", {
    href: storeStatus === '0' ? '/' : url,
    onClick: e => {
      e.preventDefault();
      handleButtonClick();
    }
  }, image ? /*#__PURE__*/React.createElement("img", {
    src: image.single || image,
    alt: name,
    className: "product-img object-contain"
  }) : /*#__PURE__*/React.createElement(NoThumbnail, null)))), /*#__PURE__*/React.createElement("div", {
    className: "absolute ltr:right-2 rtl:left-2 top-[-0.6rem] z-20"
  }, isNew && /*#__PURE__*/React.createElement(NewItemIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col items-center justify-center px-6 text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full mb-4"
  }, isSpicy && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/assets/card/spicy-icon.svg",
    alt: "Spicy",
    className: "absolute ltr:block rtl:hidden ltr:right-0 rtl:left-0 top-[-48px] rotate-[15deg] z-30"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/assets/card/spicy-icon-ar.svg",
    alt: "\u062D\u0627\u0631",
    className: "absolute ltr:hidden rtl:block ltr:right-0 rtl:left-0 top-[-48px] rotate-[-15deg] z-30"
  })), /*#__PURE__*/React.createElement("a", {
    href: url,
    onClick: e => {
      e.preventDefault();
      handleButtonClick();
    },
    className: "product-title uppercase font-zoom-pro-compact text-[2rem] font-[700] block leading-tight text-[#060708]"
  }, isAr ? nameAr || name : name), /*#__PURE__*/React.createElement("p", {
    className: "product-description-card font-rubik text-[1.4rem] font-[500] mt-2 text-[#8C8C8C]  line-clamp-2 w-full text-center"
  }, isAr && descriptionAr ? descriptionAr : description)), /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#F1F1F1]/40 rounded-[0.4rem] py-2 flex items-center justify-center"
  }, hasPrice ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-baseline gap-1"
  }, isAr ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "product-price !font-rubik text-[2.2rem] font-bold text-[#060708]"
  }, displayPrice), /*#__PURE__*/React.createElement("span", {
    className: "product-currency text-[1.4rem] font-bold text-[#060708]"
  }, "\u062C\u0645")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "product-currency  text-[1.4rem] font-bold text-[#060708]"
  }, currency), /*#__PURE__*/React.createElement("span", {
    className: "product-price !font-rubik text-[2.2rem] font-bold text-[#060708]"
  }, displayPrice))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "font-medium text-[1.4rem] text-[#060708]"
  }, _('Price upon selection')), /*#__PURE__*/React.createElement("span", {
    className: "product-price text-[1.8rem] text-[#060708]"
  }, displayPrice))))), stockAvailability && /*#__PURE__*/React.createElement("div", {
    className: "add-to-cart-section relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: !isCustomizable ? '/assets/card/card-red-lines.svg' : '/assets/card/card-black-lines.svg',
    alt: !isCustomizable ? 'red-lines' : 'black-lines',
    className: "red-lines-img"
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex items-center justify-between px-6"
  }, !isCustomizable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: " ".concat(storeStatus === '0' ? 'text-[#afafaf]' : 'text-primary', " uppercase bg-[#fff] rounded-[0.4rem] p-[0.2rem] font-bold text-[1.75rem]")
  }, _('Add to cart')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleButtonClick,
    disabled: loading || storeStatus === '0',
    className: "rounded-full ".concat(storeStatus === '0' ? 'opacity-30' : 'opacity-100', "  bg-primary text-[#2A2A2A] disabled:bg-[#2A2A2A] disabled:cursor-not-allowed p-3"),
    "aria-label": "Add to cart"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "  ".concat(storeStatus === '0' ? 'opacity-30' : 'opacity-100'),
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: storeStatus === '0' ? '#afafaf' : '#fff',
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14M5 12h14"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "uppercase bg-[#fff] rounded-[0.4rem] p-[0.2rem] font-bold text-[1.6rem] ".concat(storeStatus === '0' ? 'text-[#afafaf]' : 'text-[#2A2A2A]', " cursor-pointer"),
    onClick: storeStatus === '0' ? undefined : handleButtonClick
  }, _('Customize')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleButtonClick,
    disabled: loading || storeStatus === '0',
    className: "rounded-full  disabled:cursor-not-allowed p-2",
    "aria-label": "Customize"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/card/black-arrow.svg",
    alt: "customize",
    width: 36,
    height: 36,
    className: "".concat(isAr ? 'rotate-180' : '', " ").concat(storeStatus === '0' ? 'opacity-30' : 'opacity-100')
  })))))), /*#__PURE__*/React.createElement(ProductModal, {
    isOpen: isOpen,
    product: modalProduct,
    onClose: closeModal,
    storeStatus: storeStatus
  }));
}